module.exports = __webpack_public_path__ + "img/groovy-house.4aa969ea.gif";